import type { MiniGamePageConfig } from '@/app/(football)/[team]/mini-game/_context/types';

export const steelersConfig: MiniGamePageConfig = {
  game: {
    colors: ['#ebebeb', '#fecb3e', '#ff4b47', '#120200'],
    background: {
      color: '#ebebeb',
    },
  },
  titleImage: {
    width: 258,
    height: 70,
    alt: '포항 스틸러스 미니게임 타이틀',
    marginTop: 72,
  },
  eventPeriod: {
    endDate: '2026-12-31T23:59:59+09:00',
  },
};
